/* unplugin-vue-components disabled */import i18n from '@/lang';
/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Toast from "vux/src/components/toast/index.vue"; // this line is trasformed by vux-loader
import Loading from "vux/src/components/loading/index.vue"; // this line is trasformed by vux-loader
import AMap from 'AMap';
export default {
  components: {
    Cell: Cell,
    Toast: Toast,
    Loading: Loading
  },
  props: {
    title: {
      type: String,
      default: i18n.tc("100")
    },
    address: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      currAddress: this.address,
      longitude: '',
      latitude: '',
      loadingShow: false,
      hasTitleSlot: false
    };
  },
  computed: {
    currAddressForShow: function currAddressForShow() {
      if (this.currAddress && this.currAddress.length > 0 && this.currAddress[0] !== '') {
        return this.currAddress[0];
      }
      return '';
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    address: function address(val) {
      this.currAddress = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val, this.currAddress);
      this.$emit('input', val);
    }
  },
  methods: {
    position: function position() {
      var _this = this;
      this.loadingShow = true;
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          // 是否使用高精度定位，默认:true
          timeout: 10000 // 超过10秒后停止定位，默认：5s
        });
        geolocation.getCurrentPosition(function (status, result) {
          console.log('AutoConsole: position -> status, result', status, result);
          _this.loadingShow = false;
          _this.currAddress = status;
          if (status === 'complete') {
            _this.longitude = result.position.lng;
            _this.latitude = result.position.lat;
            _this.currAddress = result.formattedAddress || '';
            _this.currValue = [_this.longitude, _this.latitude];
          } else {
            _this.$vux.toast.text(i18n.tc("482"));
          }
        });
      });
      // this.$DingTalk.device.geolocation.get({
      //   targetAccuracy: 100, // 精度半径
      //   coordinate: 1, // 1 高德坐标 2 标准坐标（无address字段）
      //   withReGeocode: true, // 是否返回逆地理编码信息
      //   useCache: true, // 是否缓存（开启后2分钟内再次请求返回缓存信息）
      //   onSuccess: ({ longitude, latitude, address }) => {
      //     this.loadingShow = false
      //     if (address && longitude && latitude) {
      //       this.longitude = longitude
      //       this.latitude = latitude
      //       this.currAddress = address
      //       this.currValue = [longitude, latitude]
      //     } else {
      //       this.$vux.toast.text('定位失败')
      //     }
      //   },
      //   onFail: e => {
      //     console.log('geolocation error')
      //   }
      // })
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};